import { defineMessages } from 'react-intl';

export default defineMessages({
  qrCode: 'Please scan this QR Code with your KLIP Wallet',
});
